import { render } from "./articles.vue?vue&type=template&id=358f810e"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__